<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark">
      <header-component></header-component>
    </nav>

    <!-- Header -->
    <header
      class="header h-fullscreen"
      style="background-image: linear-gradient(135deg, #f9f7ff 0%, #fff 50%, #f6f3ff 100%)"
    >
      <div class="container">
        <div class="row align-items-center h-100">
          <div class="col-lg-6">
            <h1 class="fw-600">
              Build your <span class="text-warning">Brand.</span><br /><span class="text-info"
                >Sell</span
              >
              more stuff.
            </h1>
            <p class="lead mt-5 mb-8">Domain And Hosting</p>
          </div>

          <div class="col-lg-5 ml-auto d-none d-lg-block">
            <img src="../../../assets/img/18.png" alt="img" />
          </div>
        </div>
      </div>
    </header>
    <!-- /.header -->

    <!-- Main Content -->
    <main class="main-content">
      <!--
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Send better email
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      !-->
      <section class="section">
        <div class="container">
          <header class="section-header">
            <h2>Cloud Services</h2>
            <hr />
            <p class="lead">
              Whether you need to sell your products, share some big news, or tell a story, our
              cloud service makes it easy to create tailor-made cloud solution for your requirement.
            </p>
          </header>

          <div class="row gap-y">
            <div class="col-md-8 mx-auto mb-7">
              <!-- <img src="../assets/img/preview/feature-tablet.png" alt="..." data-aos="fade-up" data-aos-duration="2000"> -->
            </div>

            <div class="w-100"></div>

            <div class="col-md-6 col-xl-4">
              <div class="media">
                <div class="lead-6 line-height-1 text-lighter w-70px">
                  <i class="icon-mobile"></i>
                </div>
                <div class="media-body">
                  <h5>Launch VPC</h5>
                  <p>Customized VPC configuration in AWS Cloud</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="media">
                <div class="lead-6 line-height-1 text-lighter w-70px">
                  <i class="icon-gears"></i>
                </div>
                <div class="media-body">
                  <h5>Serverless</h5>
                  <p>Deploy microservice(lambda) using a serverless framework</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="media">
                <div class="lead-6 line-height-1 text-lighter w-70px">
                  <i class="icon-tools"></i>
                </div>
                <div class="media-body">
                  <h5>AWS Cognito</h5>
                  <p>Customized authentication and authorization framework for your app</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="media">
                <div class="lead-6 line-height-1 text-lighter w-70px">
                  <i class="icon-layers"></i>
                </div>
                <div class="media-body">
                  <h5>Migration as a service</h5>
                  <p>Migrate existing infrastructure to AWS, Database migration for RDS, Aurora</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="media">
                <div class="lead-6 line-height-1 text-lighter w-70px">
                  <i class="icon-recycle"></i>
                </div>
                <div class="media-body">
                  <h5>Automation</h5>
                  <p>
                    Automate your infra provisioning using tools like CloudFormation and Terraform
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="media">
                <div class="lead-6 line-height-1 text-lighter w-70px">
                  <i class="icon-recycle"></i>
                </div>
                <div class="media-body">
                  <h5>CI/CD Pipeline</h5>
                  <p>
                    Implement a CI/CD pipeline using tools like AWS Code Pipeline, Github Actions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | FAQ
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      !-->
    </main>
  </div>
</template>
<script>
import header from "../../../components/Header";
export default {
  data: () => {
    return {};
  },
  components: {
    "header-component": header,
  },
};
</script>
